import { Routes, Route, Navigate } from "react-router-dom";
import MobileLayout from "../components/MobileLayout";
import MobileHome from "../pages/Home";
import Invoices from "../pages/Invoices";
import Expenses from "../pages/Expenses";
import ApproveDocuments from "../pages/ApproveDocuments";
import SignDocuments from "../pages/SignDocuments";
import Vacations from "../pages/Vacations";
import Timesheets from "../pages/Timesheets";
import WeeklyView from "../pages/Timesheets/components/WeeklyView";
import Trips from "../pages/Trips";
import TripsheetDocumentsList from "./TripsheetDocumentsList";
import Vehicles from "../pages/Vehicles";

const MobileRoutes = () => {
  return (
    <Routes>
      <Route element={<MobileLayout />}>
        {/* Rota principal /mobile */}
        <Route index element={<MobileHome />} />
        
        {/* Exemplo: <Route path="timesheet" element={<MobileTimesheet />} /> */}

        {/* Rota das faturas */}
        <Route path="invoices" element={<Invoices />} />

        {/* Rota das despesas */}
        <Route path="expenses" element={<Expenses />} />

        {/* Rota para aprovar documentos */}
        <Route path="approve-documents" element={<ApproveDocuments />} />

        {/* Rota para assinar documentos */}
        <Route path="sign-documents" element={<SignDocuments />} />

        {/* Rota para agendar férias */}
        <Route path="vacations" element={<Vacations />} />

        {/*Rota para mapa de horas */}
        <Route path="timesheets" element={<Timesheets />} />

        {/**Rota para as viagens */}
        <Route path="trips" element={<Trips />} />

        <Route path="documents" element={<TripsheetDocumentsList />} />

        <Route path="vehicles" element={<Vehicles/>} />

        <Route path="timesheets/:id" element={<WeeklyView />} />
        {/* <Route path="timesheets" element={<MobileTimesheetsPage />} /> */}
        {/* Fallback: redireciona para a raiz do /mobile se a rota não existir */}
        {/* Redireciona qualquer rota inválida dentro de /mobile para a Home */}
        <Route path="*" element={<Navigate to="/mobile" replace />} />
      </Route>
    </Routes>
  );


  
};

export default MobileRoutes;